<p-toast></p-toast>
<inpla-navigation-error-toast />
@if (userPermissionsStore.status() === 'error') {
  <inpla-permissions-retry-banner (retry)="onPermissionsRetry()" />
}
@if (isAwaitingPermissions()) {
  <inpla-app-loading-screen class="app-permissions-loading" />
}
<router-outlet></router-outlet>
